import React from 'react';
import { useAuth } from '../hooks/useAuth';

const Dashboard = () => {
  const { user } = useAuth();

  return (
    <div>
      <h2 className="text-2xl font-bold mb-4">Dashboard</h2>
      <p>Bienvenido, {user.displayName || user.email}!</p>
      {/* Aquí puedes añadir más componentes del dashboard según el tipo de usuario */}
    </div>
  );
};

export default Dashboard;